// extracted by mini-css-extract-plugin
module.exports = {"markingOptions":"styles__markingOptions___3kVAu","title":"styles__title___2bI3l","versions":"styles__versions___3Z3Iu"};